import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GbCheckoutComponent } from './gb-checkout/gb-checkout.component'
import { GbCheckoutGuard } from 'libs/gb-front/checkout/util/src'

export class CheckoutConstants {
  public static CHECKOUT: string = 'checkout'
  public static INVOICE: string = 'invoice'
}

const routes: Routes = [
  {
    path: '',
    redirectTo: CheckoutConstants.INVOICE,
    pathMatch: 'full',
  },
  {
    path: CheckoutConstants.INVOICE,
    canActivate: [GbCheckoutGuard],
    component: GbCheckoutComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GbFrontCheckoutRoutingModule {}
